export default class HotelOrder { // 酒店订单类
  constructor(details) {
    if (details) {
      for (let key of Object.keys(details)) {
        this[key] = details[key] ? JSON.parse(JSON.stringify(details[key])) : null
      }
    }
    this.OrderID = details && details.OrderID ? details.OrderID : null // 订单ID
    this.CityName = details && details.CityName ? details.CityName : '' // 城市名称
    this.CityID = details && details.CityID ? details.CityID : '' // 城市ID
    this.HotelID = details && details.HotelID ? details.HotelID : '' // 酒店ID
    this.CheckInDate = details && details.CheckInDate ? details.CheckInDate : this.beTime(new Date()) // 入住日期
    this.CheckOutDate = details && details.CheckOutDate ? details.CheckOutDate : this.beTime(new Date().setDate(new Date().getDate() + 1)) // 离店日期
    this.RoomID = details && details.RoomID ? details.RoomID : '' // 房型ID
    this.RatePlanID = details && details.RatePlanID ? details.RatePlanID : '' // 产品价格计划ID
    this.RoomAmount = details && details.RoomAmount ? details.RoomAmount : 1 // 房间数
    this.CustomItem = details && details.CustomItem ? details.CustomItem : {} // 自定义项(所有乘客一样)
    this.Contacts = details && details.Contacts ? details.Contacts : [] // 联系人信息
    this.PayType = details && details.PayType ? details.PayType : null // 支付类型
    this.Purpose = details && details.Purpose ? details.Purpose : '' // 差旅目的
    this.AuthorizationCode = details && details.AuthorizationCode ? details.AuthorizationCode : '' // 授权码
    this.AppointVettingPersonID = details && details.AppointVettingPersonID ? details.AppointVettingPersonID : '' // 选择的指定审批人ID
    this.AppointVettingPersonName = details && details.AppointVettingPersonName ? details.AppointVettingPersonName : '' // 选择的指定审批人姓名
    this.ViolationRankName = details && details.ViolationRankName ? details.ViolationRankName : '' // 违反差旅政策姓名
    this.ViolationRankReason = details && details.ViolationRankReason ? details.ViolationRankReason : '' // 违反差旅政策原因
    this.Guests = details && details.Guests ? details.Guests : [] // 入住人列表
    this.ArrivalTime = details && details.ArrivalTime ? details.ArrivalTime : '18:00' // 到达时间(HH：mm)
    this.SpecificRequirements = details && details.SpecificRequirements ? details.SpecificRequirements : '' // 特殊需求
    this.TravelType = details && details.TravelType ? details.TravelType : null // 因公因私
    this.OrderType = details && details.OrderType ? details.OrderType : null // 订单类型
    this.VettingProcessList = details && details.VettingProcessList ? details.VettingProcessList : [] // 审批流列表
    this.filters = details && details.filters ? details.filters : [] // 筛选条件
    this.UseCoupons = details && details.UseCoupons ? details.UseCoupons : [] // 抵用券信息

    // 国际酒店
    this.AdultAmount = details && details.AdultAmount ? details.AdultAmount : 0
    this.NationalityName = details && details.NationalityName ? details.NationalityName : '中国'
    this.NationalityCode = details && details.NationalityCode ? details.NationalityCode : 'CN'

    this.ExtendField1 = details && details.ExtendField1 ? details.ExtendField1 : '' // 扩展字段1
    this.ExtendField2 = details && details.ExtendField2 ? details.ExtendField2 : '' // 扩展字段2
    this.ExtendField3 = details && details.ExtendField3 ? details.ExtendField3 : '' // 扩展字段3
    this.ExtendField4 = details && details.ExtendField4 ? details.ExtendField4 : '' // 扩展字段4
    this.ExtendField5 = details && details.ExtendField5 ? details.ExtendField5 : '' // 扩展字段5
    this.AttachFiles = details && details.AttachFiles ? details.AttachFiles : [] // 上传图片

    /** 前端用于显示, 自定义的字段 */
    this.City = details && details.City ? details.City : null
    this.Hotel = details && details.Hotel ? details.Hotel : null
    this.Latitude = details && details.Latitude ? details.Latitude : null // 纬度
    this.Longitude = details && details.Longitude ? details.Longitude : null // 经度
    this.Address = details && details.Address ? details.Address : null // 地址
    this.isCollectionOrder = details && details.isCollectionOrder ? details.isCollectionOrder : false // 是否是收藏下单]
    this.LowRate = details && details.LowRate ? details.LowRate : 0 // 抵用券信息
    this.HighRate = details && details.HighRate ? details.HighRate : undefined // 抵用券信息
    this.StarRate = details && details.StarRate ? details.StarRate : undefined // 抵用券信息
    /*******************************************************************************************************************************************************/
  }
  beTime(ms, format = 'yyyy-MM-dd') {
    let isDate = ms instanceof Date
    if (!isDate && `${ms}`.includes('-') && !`${ms}`.startsWith('-')) {
      let year = '1900'
      let month = '01'
      let day = '01'
      let hours = '00'
      let minutes = '00'
      let seconds = '00'
      let res = ''
      if (ms.includes(' ')) {
        let date = ms.split(' ')[0]
        year = date.split('-')[0]
        month = date.split('-')[1]
        day = date.split('-')[2]
        let time = ms.split(' ')[1]
        let timelist = time.split(':')
        timelist.length > 0 && (hours = timelist[0]);
        timelist.length > 1 && (minutes = timelist[1]);
        timelist.length > 2 && (seconds = timelist[1]);
        res = format.replace('yyyy', year).replace('MM', month).replace('dd', day).replace('hh', hours).replace('mm', minutes).replace('ss', seconds)
      } else {
        year = ms.split('-')[0]
        month = ms.split('-')[1]
        day = ms.split('-')[2]
        res = format.replace('yyyy', year).replace('MM', month).replace('dd', day)
      }
      return res
    } else {
      let date = ''
      if (isDate) {
        date = new Date(ms)
      } else {
        let val = ms.toString().length <= 10 ? ms * 1000 : ms
        date = new Date(val)
      }
      /** 将获取的日期格式转成北京时间 */
      // let currentDate = new Date()
      // let tmpMins = date.getMinutes()
      // let timeZone = currentDate.getTimezoneOffset() + 480
      // date = new Date(date.setMinutes(tmpMins + timeZone))
      /**********************************************************************************************/
      var fmt = format // yyyy-MM-dd hh:mm
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
        }
      }
      return fmt
    }
  }
}
